import { renderIcon } from "discourse/lib/icon-library";

export function iconNode(id, params) {
  return renderIcon("node", id, params);
}
